import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext"; // + AJOUT
import { translations } from "../api/translations";
import TalkmateLogo from "../images/talk_mate_horizontal.png";

export default function NavBar() {
  const { translate, language, setLanguage } = useContext(LanguageContext);
  const { currentUser } = useAuth(); // + AJOUT
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const cycleLanguage = () => {
    const supported = Object.keys(translations || { en: {}, fr: {} });
    const idx = supported.indexOf(language);
    const next = supported[(idx + 1) % supported.length];
    setLanguage(next);
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        py: 2,
        bgcolor: "background.paper",
        color: "text.primary",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Box
          component={RouterLink}
          to="/"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <img
            src={TalkmateLogo}
            alt="Talkmate"
            style={{ height: 36, display: "block" }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Button
            component={RouterLink}
            to="/aboutus"
            sx={{ textTransform: "none", color: "text.primary", mx: 1 }}
          >
            {translate("NavOffer")}
          </Button>
          <Button
            component={RouterLink}
            to="/pricing"
            sx={{ textTransform: "none", color: "text.primary", mx: 1 }}
          >
            {translate("Pricing")}
          </Button>

          <Button
            onClick={cycleLanguage}
            variant={isDark ? "contained" : "outlined"}
            size="small"
            sx={{
              mx: 1,
              minWidth: 36,
              width: 36,
              height: 36,
              p: 0,
              borderRadius: "50%",
              fontSize: 12,
              lineHeight: 1,
              textAlign: "center",
              fontWeight: 700,
            }}
            title={`Langue: ${language?.toUpperCase()} (cliquer pour changer)`}
          >
            {String(language || "en").toUpperCase()}
          </Button>

          {currentUser ? (
            <Button
              component={RouterLink}
              to="/app" // ← destination “Mes tickets” (adapte si besoin)
              variant="contained"
              color="primary"
              sx={{
                textTransform: "none",
                ml: 2,
                ...(isDark && { color: "primary.contrastText" }),
              }}
            >
              {translate("MyTickets")}
            </Button>
          ) : (
            <Button
              component={RouterLink}
              to="/login"
              variant={isDark ? "contained" : "outlined"}
              color="primary"
              sx={{
                textTransform: "none",
                ml: 2,
                ...(isDark
                  ? { color: "primary.contrastText" }
                  : {
                      color: "text.primary",
                      borderColor: "divider",
                      "&:hover": {
                        borderColor: "primary.main",
                        bgcolor: "action.hover",
                      },
                    }),
              }}
            >
              {translate("SignIn")}
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
